import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { adminAssessmentPaymentListHeader, adminAssessmentPaymentListWidth } from 'constants/pagination';
import { getWidthRation } from 'utils/calculateWdith';
import { AdminAssessmentPaymentPaginationProps } from 'models/Admin/AdminPaginationTypes';
import { NothingDataInManagingPatientsPagination } from 'pages/Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import CustomedPagination from 'components/Pagination/CustomedPagination';
import AdminAssessmentPaymentPaginationTable from './AdminAssessmentPaymentPaginationTable';

const AdminAssessmentPaymentPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    handlePageGroup,
    handlePageChange,
    currentData,
    totalCount,
    handleResetButton,
    onDataUpdate,
}: AdminAssessmentPaymentPaginationProps) => {
    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {adminAssessmentPaymentListHeader.map((name, idx) => {
                        return (
                            <TableCell key={idx} $width={getWidthRation(adminAssessmentPaymentListWidth[idx])} $type='header' $justifyContent='space-between' cellType={name.type}>
                                {name.title}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {currentData && currentData.length > 0 ? (
                    <AdminAssessmentPaymentPaginationTable currentData={currentData} totalCount={totalCount} currentPage={currentPage} onDataUpdate={onDataUpdate} />
                ) : (
                    <NothingDataInManagingPatientsPagination handleResetButton={handleResetButton} />
                )}
            </TableLayout>
            <CustomedPagination 
                currentPage={currentPage} 
                totalPages={totalPages} 
                onChangeCurrentPage={handlePageChange} 
                onChangeSectionIdx={handlePageGroup}
                sectionIndex={pageGroup}
            />
        </Layout>
    );
};

export default AdminAssessmentPaymentPagination;